import { render, staticRenderFns } from "./create-preview.vue?vue&type=template&id=45e02980&scoped=true"
import script from "./create-preview.vue?vue&type=script&lang=js"
export * from "./create-preview.vue?vue&type=script&lang=js"
import style0 from "./create-preview.vue?vue&type=style&index=0&id=45e02980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e02980",
  null
  
)

export default component.exports